import { render, staticRenderFns } from "./CustomLoading.vue?vue&type=template&id=2495cc22&"
import script from "./CustomLoading.vue?vue&type=script&lang=js&"
export * from "./CustomLoading.vue?vue&type=script&lang=js&"
import style0 from "./CustomLoading.vue?vue&type=style&index=0&id=2495cc22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports